// @flow
import React from 'react';
import { Link, graphql } from 'gatsby';

import Tag from '../components/TagHeading';
import Layout from '../components/Layout';
import SEO from '../components/seo';
import s from './s.module.scss';

const Home = ({
  data: {
    site: {
      siteMetadata: { title: siteTitle, subTitle },
    },
    postsByTags: { group: tagGroups },
  },
  location,
}) => {
  return (
    <Layout location={location} className={s.noteListing}>
      <SEO
        title={`${siteTitle} | ${subTitle}`}
        keywords={[`blog`, `gatsby`, `javascript`, `react`]}
      />
      {tagGroups
        .sort((a, b) => a.fieldValue.localeCompare(b.fieldValue)) // sort by alphabetical order
        .map(tagGroup => (
          <div key={tagGroup.fieldValue} className={s.topic}>
            <Tag
              tag={tagGroup.fieldValue}
              className={s.tagsOnHomePageListing}
            />
            <ul className={s.tagPostListing}>
              {tagGroup.nodes.map(({ fields, frontmatter, timeToRead }) => {
                const title = frontmatter.title || fields.slug;
                const subtitle = frontmatter.subtitle || '';
                return (
                  <li key={fields.slug}>
                    <Link style={{ boxShadow: `none` }} to={fields.slug}>
                      {title}
                      {subtitle && <> - {subtitle}</>}
                    </Link>
                    <span className={s.read} to={fields.slug}>
                      {timeToRead} min read
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M21,8.5A2.50294,2.50294,0,0,0,18.5,6h-1a.5.5,0,0,0,0,1h1A1.50164,1.50164,0,0,1,20,8.5v2.87952A3.96934,3.96934,0,0,0,13.05042,13.5H10.94958A3.96934,3.96934,0,0,0,4,11.37952V8.5A1.50164,1.50164,0,0,1,5.5,7h1a.5.5,0,0,0,0-1h-1A2.50294,2.50294,0,0,0,3,8.5V14a3.98989,3.98989,0,0,0,7.94958.5h2.10084A3.98989,3.98989,0,0,0,21,14ZM7,17a3,3,0,1,1,3-3A3.0034,3.0034,0,0,1,7,17Zm10,0a3,3,0,1,1,3-3A3.0034,3.0034,0,0,1,17,17Z" />
                      </svg>
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
    </Layout>
  );
};

export default Home;

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        subTitle
      }
    }
    postsByTags: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { listed: { ne: false } } }
    ) {
      group(field: frontmatter___tags) {
        nodes {
          fields {
            slug
          }
          frontmatter {
            title
            subtitle
          }
          timeToRead
        }
        fieldValue
      }
    }
  }
`;
